import { useQuery } from "@tanstack/react-query";
import getVariable from "api/variable/getVariable";
import { campaignDropdownListByIdKey } from "queryKeys/campaignDropdownList";

/**
 * @param {string | number} id
 * @param Object [options]
 * */
export default function useGetVariableQuery({ id }, options) {
  return useQuery({
    queryKey: campaignDropdownListByIdKey(id),
    queryFn: getVariable,
    ...options,
  });
}
